<template>
  <b-card class="mt-3" header="Emitindo Cartão de Alvará">
    <sp-form @onSubmit="onSubmit" @onReset="onReset()">
      <b-row no-gutters>

        <b-col cols="12">
          <sp-form-radio
            label=""
            @change="onChangeSearchBy"
            v-model="form.searchBy"
            :options="optionsArray"
            rules="required"
          />
        </b-col>

        <b-col cols="12" class="mt-3 p-0">
          <sp-form-townregistration
            v-model="form.documento"
            v-if="form.searchBy === 'inscricao'"
          />

          <sp-form-cpfcnpj
            v-model="form.documento"
            :mode="form.searchBy"
            v-if="form.searchBy === 'CPF' || form.searchBy === 'CNPJ'"
          />
        </b-col>

        <b-col cols="6">
          <b-col cols="12" class="bg-light p-1">
            <b-col cols="12" class="mt-3">
              <sp-captcha ref="captcha" />
            </b-col>
            <b-col cols="12" class="mt-3">
              <sp-form-input
                label="Insira o código da imagem acima *"
                v-model="form.captcha"
              />
            </b-col>
          </b-col>

          <b-col cols="12" class="mt-3" style="padding: 0">
            <sp-button
              type="submit" variant="primary" classes="control-button submit-button"
              :loading="loadingSearch" v-if="showConsultButtons"
            >
              <i class="fas fa-search" /> Consultar
            </sp-button>

            <sp-button ref="clearButton" type="reset" variant="danger" size="sm"
              class="control-button" v-if="showConsultButtons"
            >
              <i class="fas fa-eraser" /> Limpar
            </sp-button>
          </b-col>
        </b-col>

        <b-col cols="12" v-if="!showConsultButtons">
          <sp-grid
            unique="id"
            :busy="loadingSearch"
            :title="title"
            :items="items"
            :fields="fields"
            @printAction="imprimirCartao"
          />

          <sp-button
            ref="clearButton"
            type="reset"
            variant="danger"
            classes="control-button submit-button"
            v-if="!showConsultButtons"
          >
            <i class="fas fa-eraser" /> Limpar
          </sp-button>

        </b-col>

      </b-row>
    </sp-form>
  </b-card>
</template>
<script>
import { ReportService, OnlineContributorService, CartaoAlvaraService } from '@/services';

export default {
  data() {
    return {
      optionsArray: [],
      form: {
        searchBy: '',
        documento: '',

        captcha: null,
      },

      loadingSearch: false,

      title: 'Segue abaixo o resultado da sua consulta',
      fields: [
        { key: 'contribuinte', label: 'Contribuinte' },
        { key: 'inscricao', label: 'Inscrição' },
        { key: 'tipoTributo', label: 'Tributo' },
        { key: 'documento', label: 'Documento' },
        {
          type: 'action',
          key: 'print',
          color: 'info',
          label: 'Imprimir',
          icon: 'fas fa-print',
        },
      ],
      items: [],
    };
  },

  mounted() {
    this.setOptionsArray();
  },

  computed: {
    showConsultButtons() {
      return this.items.length <= 0;
    },
    navigation() {
      return this.$store.getters.getNavigation;
    },
    permissions() {
      return this.navigation.filter(
        (v) => v.leaves.filter(
          (l) => l.key === 'ECARTAOALVARA',
        ).length > 0,
      )[0].leaves[0].permissions;
    },
  },

  methods: {

    setOptionsArray() {
      this.optionsArray = [];
      const permission = this.permissions;

      if (permission.exibeInscricao) {
        this.form.searchBy = 'inscricao';
        this.optionsArray.push(
          { text: 'Número de inscrição', value: 'inscricao' },
        );
      }

      if (permission.exibeCpfCnpj) {
        this.form.searchBy = (this.form.searchBy === '') ? 'CPF' : this.form.searchBy;
        this.optionsArray.push(
          { text: 'CPF', value: 'CPF' },
          { text: 'CNPJ', value: 'CNPJ' },
        );
      }
    },

    onReset() {
      this.form = {
        searchBy: '',
        documento: '',
      };
      this.items = [];

      this.setOptionsArray();
    },

    onChangeSearchBy() {
      this.form.documento = '';
    },

    async onSubmit() {
      try {
        this.loadingSearch = true;
        this.items = [];

        if (!this.$refs.captcha.validate(this.form.captcha)) {
          this.$alertify.error('CAPTCHA inválido!');
          this.loadingSearch = false;
          return;
        }

        const { documento } = this.form;
        if (this.form.searchBy === 'inscricao') {
          this.items = await OnlineContributorService.fetchSubscriptionByTypes(
            documento,
            [4],
          );
        } else {
          this.items = await OnlineContributorService.fetchSubscriptionByDocumentsAndTypes(
            documento,
            [4],
          );
        }
        if (!this.items.length) {
          this.$alertify.warning('Sua consulta não retornou resultados.');
        }
      } catch (e) {
        if (e.response.status === 404) {
          this.$alertify.warning('Sua consulta não retornou resultados.');
        } else if (e.response.status === 412) {
          this.$alertify.warning(e.response.data.message);
        } else {
          this.$alertify.error('Erro ao realizar a consulta.');
        }
      } finally {
        this.loadingSearch = false;
      }
    },

    async imprimirCartao(index) {
      try {
        const requestParams = {
          idInscricaoFiscalizacao: this.items[index].idInscricao,
        };

        await CartaoAlvaraService.validarImpressao(requestParams);

        await ReportService.printArquivo('cartao_alvara', requestParams);

        this.$alertify.success('Cartão de Alvará gerado com sucesso...');
      } catch (e) {
        this.$alertify.warning(e);
      }
    },

  },
};
</script>
<style lang="scss" scoped>
.control-button {
  min-width: 100px;
}
.submit-button {
  margin-right: 20px;
}
</style>
